export default __webpack_public_path__ + "static/media/mewa-logo_white.e3c9ec69.png";